<div>
  <mat-card class="privacy-container">
    <!--! Title -->
    <div class="privacy-title">
      <ddc-text-gradient
        class="dashboard-header-txt dashboard-title text-2xl"
        [_text]="'Privacy Policy'"
        [_type]="'1'"
      ></ddc-text-gradient>
    </div>
    <div class="agreement-container text-sm">
      <div style="color: gray" [innerHTML]="'Last Update: ' + _lastUpdate"></div>
      <div [innerHTML]="_text"></div>
    </div>
  </mat-card>
</div>
